import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import HolidayList from "./HolidayList";

class DayOff2 extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.CompHolidayApp_GetData.execute());
            await this.props.dispatch(this.props.CompHolidayApp_ListExPO.execute());
        } catch (e) {
            console.error(e);
        }
    }
    render() {
        const info = this.props.CompHolidayApp_GetData.getRow(0);

        return (
            <PlaceholderWrapper placeholderId="10"
                                title={<><i
                                    className="fa fa-file-text-o"></i> {i18next.t("DayOff_EmployeeDayOffStatement")}</>}
                                showSplitterLine={false} canCollapse={true}>
                <HolidayList dataListItem={this.props.CompHolidayApp_ListExPO} isEkdo={info.IsEkdo === 1}/>
            </PlaceholderWrapper>
        )
    }
}

DayOff2.propTypes = {
    dispatch: PropTypes.func.isRequired,
    CompHolidayApp_GetData: PropTypes.object,
    CompHolidayApp_ListExPO: PropTypes.object
}

DayOff2.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        CompHolidayApp_GetData: state.dayOffState.CompHolidayApp_GetData,
        CompHolidayApp_ListExPO: state.dayOffState.CompHolidayApp_ListExPO
    }
}

export default connect(mapStateToProps)(DayOff2)
